import classNames from 'classnames'
import { FC, useCallback } from 'react'
import styles from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { BlueButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import format from 'date-fns/format'
import { StoreCustomerType } from 'types/storeCustomer'

type Props = {
  storeCustomers: StoreCustomerType[]
}

const CustomerList: FC<Props> = (props) => {
  const { storeCustomers } = props
  const dispatch = useDispatch()
  const goToCustomerPage = useCallback((uid: string) => {
    dispatch(push(`/customer/${uid}`))
  }, [])

  return (
    <ul className={styles.customer__list}>
      {storeCustomers.map((storeCustomer) => (
        <li key={storeCustomer.user_id} className={styles.customer__inner}>
          <div className={styles.customer__container}>
            <div className={styles.customer__label}>
              <div className={styles.customer__image}>
                <img src={storeCustomer.avatar_url || '/icon/grey/ellipsis.svg'} alt={storeCustomer.name} />
              </div>
              <Spacer size={12} />
              <h4 className={classNames(text.font_small, text.color_black, text.font_bold)}>
                {storeCustomer.name}さま
              </h4>
            </div>
            <Spacer size={8} />
            <FlexRow justifyContent={'start'}>
              <span className={classNames(text.font_small, text.color_grey_01)}>購入回数 ： </span>
              <Spacer size={2} />
              <span className={classNames(text.font_small, text.color_grey_01)}>{storeCustomer.purchase_count}回</span>
            </FlexRow>
            {storeCustomer.last_purchased_at !== null && (
              <>
                <Spacer size={8} />
                <FlexRow justifyContent={'start'}>
                  <span className={classNames(text.font_small, text.color_grey_01)}>最終購入日 ： </span>
                  <Spacer size={2} />
                  <span className={classNames(text.font_small, text.color_grey_01)}>
                    {format(storeCustomer.last_purchased_at.toDate(), 'yyyy年M月d日')}
                  </span>
                </FlexRow>
              </>
            )}
            <Spacer size={10} />
          </div>
          <BlueButton
            label={'詳細'}
            onClick={() => goToCustomerPage(storeCustomer.user_id)}
            size={'xxsmall'}
            type={'outlined'}
          />
        </li>
      ))}
    </ul>
  )
}

export default CustomerList
